import { Stack, Typography } from "@material-ui/core";
import { Box } from "@material-ui/system";
import { useMemo } from "react";
import spotIcon from "src/assets/images/green_emphasize_spot.svg";
import arrow_right from "src/assets/images/Arrow_right.svg";

export const StakingCommunity = () => {
  const texts = useMemo(() => {
    return [
      "Education: We keep writing Staking Guides that educated community to stake. ",
      "Endgement: We keep holding online AMAs and Seminal that talks about staking and governance.",
      "Community: We keep being active in the community and talking about the updates, progresses, etc.",
      "Proposal: We keep proposing ideas that balance the validator, staker and consensus.",
      "Voting: We keep actively participating in the governance proposal and vote.",
      "Tools: We keep building tools to help staker and validator, like stake wallet, node monitor, etc. ",
    ];
  }, []);

  return (
    <Box p="50px 40px 60px"> 
      <Box display="flex" alignItems="center">
        <img src={arrow_right} style={{ width: "36px", height: "36px", marginRight: "10px" }} />
        <Typography fontSize="30px" variant="bold" color="#FFFFFF">
        Being active in the community
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography fontSize="16px" color="secondary" mt="15px">
        How Wetez joins the community and plays a role as a service provider.
        </Typography>

      </Box>

      <Box
        mt="50px"
        ml="10px"
        sx={{
          backgroundColor: "#00ECA6",
          width: "1px",
          height: "16px",
        }}
      />

      <Box>
        {texts.map((text) => (
          <Stack key={text} direction="row" alignItems="center">
            <Stack alignItems="center">
              <Box
                sx={{
                  backgroundColor: "#00ECA6",
                  width: "1px",
                  height: "16px",
                }}
              />

              <img src={spotIcon} width="21px" height="21px" alt="spot" />

              <Box
                sx={{
                  backgroundColor: "#00ECA6",
                  width: "1px",
                  height: "16px",
                }}
              />
            </Stack>

            <Typography color="white" fontSize="18px" ml="10px">
              {text}
            </Typography>
          </Stack>
        ))}
      </Box>
    </Box>
  );
};
